module.exports = __webpack_public_path__ + "static/hero-headline-a7414b4b1a4b571e1e7713a18a39e359.png";